import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import Crud from "../Crud";

function Groups() {
  return (
    <Crud
      title="Groups"
      getUrl={() => "/Player/Grouping_GetList"}
      // INSERT
      insertUrl={() => "/Player/Grouping_Insert"}
      insertParams={(
        { userId },
        { groupName }
      ) => ({
        GroupName: groupName,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/Player/Grouping_Update"}
      updateParams={(
        { userId },
        { idGrouping, groupName }
      ) => ({
        IdGrouping: idGrouping,
        GroupName: groupName,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Player/Grouping_Delete"}
      deleteParams={({ userId }, id) => ({
        IdGrouping: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idGrouping"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="groupName"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Name
      </TableHeaderColumn>
    </Crud>
  );
}

export default Groups;
